import styled from '@emotion/styled';

import { Button } from 'antd';

export const StyledSubmitButton = styled(Button)`
  margin-right: 8px;
`;
